




















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DomainsApi from '@/services/rest/bemob/domains';

@Component({
  components: {
  }
})
export default class TrackingUrls extends Vue {
  domainsApi: DomainsApi = new DomainsApi();
  trackingDomain: any = null;
  userTrackingDomain: any = null;

  get clickUrl() {
    return this.userTrackingDomain
      ? 'https://' + this.userTrackingDomain.domain + '/click'
      : '';
  }

  get multiClickUrl() {
    return this.userTrackingDomain
      ? 'https://' + this.userTrackingDomain.domain + '/click/1'
      : '';
  }

  get postbackUrl() {
    return this.trackingDomain
      ? 'http://' + this.trackingDomain.domain + '/postback?cid=REPLACE&payout=OPTIONAL&txid=OPTIONAL'
      : '';
  }

  get securePostbackClickUrl() {
    return this.trackingDomain
      ? 'https://' + this.trackingDomain.domain + '/postback?cid=REPLACE&payout=OPTIONAL&txid=OPTIONAL'
      : '';
  }

  get securePostbackClickUrlTxt() {
    return this.trackingDomain
      ? 'https://' + this.trackingDomain.domain + '/conversion.txt?cid=REPLACE&payout=OPTIONAL&txid=OPTIONAL&status=OPTIONAL '
      : '';
  }

  get conversionPixelUrl() {
    return this.trackingDomain
      ? 'https://' + this.trackingDomain.domain +'/conversion.gif?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL'
      : '';
  }

  get conversionPixel() {
    return this.trackingDomain
      ? '<img src="https://' + this.trackingDomain.domain + '/conversion.gif?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL" width="1" height="1"/>'
      : '';
  }

  get conversionScript() {
    return this.trackingDomain
      ? '<script type="text/javascript" src="https://' + this.trackingDomain.domain + '/conversion.js?cid=OPTIONAL&payout=OPTIONAL&txid=OPTIONAL" />'
      : '';
  }

  get clickbankNotificationURL() {
    return this.trackingDomain
      ? `https://${this.trackingDomain.domain}/clickbank-ins`
      : '';
  }

  get clickbankSecretKey() {
    return this.$store.state.user.subdomain.toUpperCase();
  }

  formatters: any = {};

  async mounted() {
    this.$store.commit('loading', true);
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }

    this.trackingDomain = this.$store.state.cache.trackingDomains.data.find((item: any) => !item.custom);
    this.userTrackingDomain = this.$store.state.cache.trackingDomains.data.find((item: any) => item.id === this.$store.state.user.trackingDomainId);

    this.$store.commit('loading', false);
  }

}
